import(/* webpackMode: "eager" */ "/home/runner/work/wahni.io/wahni.io/src/app/learn/blogs/[slug]/blog.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/wahni.io/wahni.io/src/components/BlogPageContent.jsx");
